import moment from "moment";

export const ALL_FILTER = "all";

export const downloadFile = ({
  data,
  mimeType,
  filePrefix = "download",
  extension = "xlsx",
}) => {
  const blob = new Blob([data], { type: mimeType });

  const fileName = `${filePrefix}_${moment().format(
    "YYYY-MM-DD_HH-mm-ss"
  )}.${extension}`;

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => {
    window.URL.revokeObjectURL(link.href);
  }, 1000);
};

export const safeData = (res) =>{
  return (res?.status === 200 ? res.data || [] : []);  
}
